import styles from './PopupAddMetamask.module.scss'
import { Modal } from 'components/Modal/Modal'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import { Link } from 'react-router-dom'

type Props = {
    onClose: () => void,
}

export function PopupAddMetamask(props: Props) {
    return (
        <Modal onClose={props.onClose}>
            <form className={styles['wrapper']}>
                <div className={styles['saving']}>
                    <Icon name='metamask_png' />
                </div>
                <div>
                    <div className={styles['content']}>
                        <span className={styles['title']}>Seems like you don't have the Metamask</span>
                        <span className={styles['description']}>
                            No problem — <Link to='/' className={styles['link']}> here is instruction</Link> on how to get and use it
                        </span>
                    </div>
                </div>
                <div className={styles['button']}>
                    <Button size='l' type='dark' onClick={props.onClose}>
                        Got it 👍
                    </Button>
                </div>
            </form>
        </Modal>
    )
}

